<template>
  <div class="container">
    <div class="row">
      <div class="col-md-3">
        <img src="@/assets/not-found-image.svg" alt="Not found">
      </div>

      <div class="col-md-9">
        <div class="row">
          <h1>Page not found</h1>
          <p>Teh page you are loocking for might have been move somewhere</p>
        </div>

        <div class="row">
          <div>
            <router-link
              to="/dashboard"
              class="btn btn-danger"
              style="color: #5e50a1"
            >
              <strong class="text-white text-uppercase">Go to dashboard</strong>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script></script>

<style>
#app {
  text-align: left;
}
</style>